import type { FC } from "react"
import { useFormContext } from "react-hook-form"

import type { TransferFormValues } from "../../schemas"

import { TransferDocumentItem } from "./TransferDocumentItem"

import { DOCUMENT_UPLOAD_MIME_TYPES, DOCUMENT_UPLOAD_TYPES_LABEL } from "@/components/upload/constants"
import { MultiFileUpload } from "@/components/upload/MultiFileUpload/MultiFileUpload"
import type { UploadRowStatus } from "@/components/upload/MultiFileUpload/types"
import type { SignedUrl } from "@/graphql/codegen/graphql"

interface TransferFormDocumentsProps {
  documents: SignedUrl[]
  onDelete: (document: SignedUrl) => void
  statuses: Record<string, UploadRowStatus>
  isUploading: boolean
  readOnly?: boolean
}

export const TransferFormDocuments: FC<TransferFormDocumentsProps> = ({
  documents,
  onDelete,
  statuses,
  isUploading,
  readOnly = false,
}) => {
  const { control } = useFormContext<TransferFormValues>()

  return (
    <>
      {documents.length > 0 &&
        documents.map((document) => (
          <TransferDocumentItem
            key={document.file?.fileId}
            document={document}
            onDelete={onDelete}
            readOnly={readOnly}
          />
        ))}
      <MultiFileUpload
        control={control}
        name='documents'
        existingFileNames={documents.map((document) => document.file?.originalName ?? "")}
        allowedMimeTypes={DOCUMENT_UPLOAD_MIME_TYPES}
        allowedTypesLabel={DOCUMENT_UPLOAD_TYPES_LABEL}
        statuses={statuses}
        isUploading={isUploading}
        readOnly={readOnly}
        testIdPrefix='transfer.form-details.multi-file-upload'
      />
    </>
  )
}
